module.exports = __webpack_public_path__ + "img/bino.405d3aa8.webp";